// extracted by mini-css-extract-plugin
module.exports = {"container":"EditorPlaceholder_container__2WP0g"};